module.exports = __webpack_public_path__ + "img/dimensi_dan_panjang.dbb52e44.svg";